import HtmlParser from "react-html-parser";
import sanitize from "sanitize-html";
import { Trace } from "../../telemetry/Trace";
import { dashboard } from "../../telemetry/TraceLogging";
/**
 * Creates a formatted string from a template where the value for {foo} in the format is substituted from
 * the value keyed by "foo". For example formatString("{foo}", { "foo": "x" }) would return "x". In general,
 * you should use templates like `${value}` for creating strings, but formatString should be used when
 * constructing strings from localized string resources as the former is not possible..
 *
 * Also sanitizes html strings and converts tags to rich text formatting.
 */
export function formatString(format, values) {
    let result = format;
    if (values) {
        const keys = Object.keys(values);
        for (let i = 0; i < keys.length; ++i) {
            const key = keys[i];
            result = result.replace(new RegExp(`\\{${key}\\}`, "g"), values[key]);
        }
    }
    return HtmlParser(sanitize(result));
}
/**
 * Attempts to parse a given string to a JSON object
 * @param {string} jsonString - The string to parse.
 * @returns {any} - the parsed object if successful, or null otherwise.
 */
export function tryParseJson(jsonString) {
    if (!jsonString) {
        return null;
    }
    try {
        return JSON.parse(jsonString);
    }
    catch (error) {
        Trace.logEvent(dashboard, "tryParseJsonFailed", 1 /* information */, {
            jsonString: jsonString,
            reason: error,
        });
        return null;
    }
}
